import { css } from '@emotion/react';
import { Heading, Paragraph, semanticTokens, tokens } from '@flysas-tech/commercial-ui';
import { t } from 'i18n';
import { formatCurrency } from 'shared';

import { PriceBreakdownType } from '../cart/types';

const styles = {
  container: css`
    display: flex;
    flex-direction: column;
    gap: ${tokens.dimension['space-7']};
  `,
  breakdownContainer: css`
    margin: 0;
    display: flex;
    flex-direction: column;
    gap: ${tokens.dimension['space-6']};
  `,
  priceItem: css`
    display: flex;
    justify-content: space-between;

    & > dt,
    & > dd {
      font-size: ${tokens.fontSize.paragraph['paragraph-2']};
      color: ${semanticTokens.color.text.primary};
    }

    & > p {
      font-weight: 700;
    }
  `,
};

type TaxesAndFeesProps = {
  pos: string;
  totalTax: string;
  taxBreakdown: PriceBreakdownType[];
};

export const TaxesAndFees = ({ pos, taxBreakdown, totalTax }: TaxesAndFeesProps) => {
  return (
    <div css={styles.container}>
      <dl css={styles.breakdownContainer}>
        {taxBreakdown.map(({ name, price, code }) => (
          <div key={code} css={styles.priceItem}>
            <dt dangerouslySetInnerHTML={{ __html: name }}></dt>
            <dd>{formatCurrency(price, pos)}</dd>
          </div>
        ))}
      </dl>

      <div css={styles.priceItem}>
        <Heading color="primary" size="title-2" as="h1">
          {t('common:total')}
        </Heading>
        <Paragraph color="primary" size={'paragraph-3'}>
          {totalTax}
        </Paragraph>
      </div>
    </div>
  );
};
